import { client } from "api";

export type ExcludePhotosFromPdfRequest = { ids: string[]; excluded: boolean };
export type ExcludePhotosFromPdfResponse = { ids: string[]; excluded: boolean };

export const excludePhotosFromPdf = (request: ExcludePhotosFromPdfRequest) =>
  client.post<null>(`/bin/set-excluded-from-pdf`, request).then(() => request);
